module.exports = __webpack_public_path__ + "img/harmonyOS_bg9.516a6055.jpg";